import cn from 'classnames';
import type { FCP } from 'types';

import classes from './index.module.css';

export const List = ({ children, className }: FCP) => (
  <ul className={cn('z-m-0 z-pl-0', classes.container, className)}>{children}</ul>
);
